<script setup lang="ts">
import type { CapturePhoto } from "@/types/capture"

const props = withDefaults(
  defineProps<{
    photos: CapturePhoto[]
    modelValue: string[]
    disabled?: boolean
  }>(),
  { disabled: false },
)

const emit = defineEmits<{
  "update:modelValue": [photoIds: string[]]
}>()

function toggle(photoId: string, selected: boolean) {
  const next = new Set(props.modelValue)
  if (selected) next.add(photoId)
  else next.delete(photoId)
  emit(
    "update:modelValue",
    props.photos.filter((photo) => next.has(photo.id)).map((photo) => photo.id),
  )
}
</script>

<template>
  <div class="grid grid-cols-2 gap-2 sm:grid-cols-3">
    <label
      v-for="photo in photos"
      :key="photo.id"
      :data-photo-id="photo.id"
      :data-selected="modelValue.includes(photo.id)"
      class="border-default has-checked:border-primary has-checked:ring-primary relative cursor-pointer overflow-hidden rounded-md border has-checked:ring-2"
      :class="disabled ? 'cursor-not-allowed opacity-50' : ''"
    >
      <img
        :src="photo.large_url"
        :alt="`Capture photo ${photo.position}`"
        class="aspect-square w-full object-cover"
      />
      <span
        class="bg-default/90 absolute top-2 right-2 flex size-8 items-center justify-center rounded-full"
      >
        <input
          type="checkbox"
          :checked="modelValue.includes(photo.id)"
          :disabled="disabled"
          class="size-5"
          :aria-label="`Select capture photo ${photo.position}`"
          @change="toggle(photo.id, ($event.target as HTMLInputElement).checked)"
        />
      </span>
    </label>
  </div>
</template>
